import React from 'react'
import styles from "../css/SkeletonPage.module.css"
import SkeletonNote from './SkeletonNote'
import LogoItem from '../../Logo/LogoItem'

const SkeletonPage = () => {

  return (
        <div className={styles.wrapper}>
            <nav className={styles.navbar}>
                <div className = {styles.navbarContent}>
                    <LogoItem skeleton = {true}/>
                    <div className={styles.navSearch}></div>
                    <div className={styles.navRight}>
                        <div className={styles.navAvatar}></div>
                    </div>
                </div>
            </nav>
            <div className={styles.pageHeader}>
                <div className = {styles.headerContent}>
                    <div className={styles.pageHeaderLeft}>
                        <div className={styles.pageTitle}></div>
                        <div className={styles.pageCount}></div>
                    </div>
                    <div className={styles.pageActions}>
                        <div className={styles.btnSort}></div>
                        <div className={styles.btnFilter}></div>
                        <div className={styles.btnAdd}></div>
                    </div>
                </div>
            </div>
            <div className = {styles.searchWrapper}>
                <div className={styles.navSearch}></div>
            </div>
            <div className={styles.main}>
                <main className={styles.content}>
                    <SkeletonNoteContainer/>
                </main>
            </div>
        </div>
  )
}

export const SkeletonNoteContainer = () => {
    return (
        <div className={styles.notesGrid}>
            {[...Array(10).keys()].map((_,index)=>(
                <SkeletonNote key = {index}/>
            ))}
        </div>
    )
}

export default SkeletonPage